import React from 'react'
import { Text } from '@mantine/core'

import { Card } from '@/components/Event/Detail/components/Card'

// The mono font used for on-screen SA script text; shared with other CR Form blocks
// that render script copy outside a plain ScriptBlock (e.g. the mandatory-policy list).
export const scriptStyles = {
  fontFamily: 'Aeonik Mono Medium, monospace',
} as const

// Standardized on-screen script text the SA reads aloud, styled consistently
// across all CR Form sections.
export const ScriptBlock: React.FC<{
  heading: string
  children: React.ReactNode
}> = ({ heading, children }) => (
  <Card heading={heading}>
    <Text size="sm" color="gray.9" sx={scriptStyles}>
      {children}
    </Text>
  </Card>
)
